<template>
  <router-view></router-view>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: 'App',
  components: {
   
  },
  mounted() {
    let user = Cookies.get("user");
    
    if (user) {
      
      let acc = JSON.parse(user)
      this.$store.commit("setUser", acc);
    }
    let Frontend_localtime = new Date().getTime();
   
    setTimeout(() => {
      let Frontend_msec_onpage = new Date().getTime() - Frontend_localtime;
      Cookies.set('time_onpage', Frontend_msec_onpage);
    }, 100);
  }
}
</script>

<style>

</style>
